<template>
    <div class="content">
        <div class="location-title">
            <div class="location-name">
                {{loca.name}}
            </div>
            <div v-if="loca.vicinity !== undefined">
            <div class="location-vicintiy">
                {{loca.vicinity}}
            </div>
            </div>
        </div>
        <div class="location-rating">
            {{loca.rating}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "GoogleMapsInfoWindow",
        props: [
            "loca"
        ]
    }
</script>

<style scoped>
    .content {
        overflow-x: scroll;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
    }
    .location-title {
        text-align: left;
        font-size: 12px;
        line-height: 12px;
        padding: 12px;
    }
    .location-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-bottom: 6px;
        font-weight: bold;
    }
    .location-vicintiy {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-bottom: 6px;
    }

    @media screen and (min-width: 640px){
        .content {
            overflow-x: unset;
        }
    }

</style>